import { produktPreisMonat } from "../constants";

const calculateZeitersparnisProMonat = (rechercheAufwand) => {
  // only needs 25% of the usual time
  return rechercheAufwand * 0.75;
};

const calculateEinsparpotenzialProMonat = (
  gehaltProMonat,
  wochenarbeitszeit,
  rechercheAufwand
) => {
  if (wochenarbeitszeit <= 0) {
    throw new Error("invalid wochenarbeitszeit");
  }
  const gehaltProStunde = gehaltProMonat / 4 / wochenarbeitszeit;
  const rechercheKostenOhneProdukt = gehaltProStunde * rechercheAufwand;
  const rechercheKostenMitProdukt = gehaltProStunde * rechercheAufwand * 0.25;
  const result =
    rechercheKostenOhneProdukt -
    (rechercheKostenMitProdukt + produktPreisMonat);
  return result;
};

export { calculateZeitersparnisProMonat, calculateEinsparpotenzialProMonat };
